var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.customer)?_c('div',{staticClass:"on-board"},[(!_vm.hasCard)?_c('on-board-card-view'):_c('on-board-requirements-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }